import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getRadioCheckGroupTestIds = createTestIds('radio-check-group', [...elements] as const);
